import React, { Fragment, useEffect, useLayoutEffect, useState } from "react";
import clsx from "clsx";
import { func, oneOf } from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { settingMenuList, sidebarLinkList } from "./MainLayoutData";
import { SubMenu, SubscriptionItem } from "./components";
import {
  GUEST_ROLE,
  INSTRUCTOR_ROLE,
  SIDEBAR_MODE,
  SIDEBAR_STATUS,
  STUDENT_ROLE,
} from "@constants";
import { AccessControl } from "@components";
import { useWindowSize } from "@hooks";
import styles from "./styles/MainSidebar.module.css";
import { useDispatch, useSelector } from "react-redux";
import { allSubscriptionAction } from "@redux/actions";

function MainSidebar({ status, mode, onChangeSidebar }) {
  // state
  const [activeTab, setActiveTab] = useState("");
  const [showAllSubscription, setShowAllSubscription] = useState(false);

  // variables
  const isShow = status !== SIDEBAR_STATUS.HIDE;
  const isShowMini = status === SIDEBAR_STATUS.MINI;

  const sidebarClass = !isShow
    ? styles.hideSidebar
    : isShowMini
    ? styles.miniSidebar
    : styles.showSidebar;

  let sidebarLinkListData = [];
  let settingMenuListData = [];

  switch (mode) {
    case SIDEBAR_MODE.DASHBOARD:
      sidebarLinkListData = sidebarLinkList.dashBoard;
      settingMenuListData = settingMenuList.dashBoard;
      break;
    case SIDEBAR_MODE.ADMIN:
      sidebarLinkListData = sidebarLinkList.admin;
      settingMenuListData = settingMenuList.admin;
      break;
    default:
      sidebarLinkListData = sidebarLinkList.default;
      settingMenuListData = settingMenuList.default;
      break;
  }

  // logics before hooks

  // hooks
  let location = useLocation();
  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const { allCategories } = useSelector((state) => state.category);
  const { unsubscribe, subscribe, allSubscription } = useSelector(
    (state) => state.subscription
  );

  const totalSubscription = allSubscription.data?.length;
  const numOfShowSubscription = 4;

  // logics
  const handleAfterClickLink = () => {
    if (width <= 1024) {
      onChangeSidebar(SIDEBAR_STATUS.HIDE);
    }
  };
  if (allCategories.data) {
    const categoryOptions = [];
    for (const category of allCategories.data) {
      for (const subCategory of category.subCategories) {
        categoryOptions.push({
          title: subCategory.name,
          path: `explore?CategoryId=${subCategory.id}`,
        });
      }
    }
    sidebarLinkListData = sidebarLinkListData.map((each) =>
      each.title === "Categories" ? { ...each, subNav: categoryOptions } : each
    );
  }

  // UI partials
  let subscriptionMenu = null;
  if (mode === SIDEBAR_MODE.DEFAULT) {
    subscriptionMenu = (
      <Fragment>
        <AccessControl targetRoles={[STUDENT_ROLE, INSTRUCTOR_ROLE]}>
          <Fragment>
            {!isShowMini && (
              <div
                className={clsx(
                  styles.sidebarTitle,
                  "d-flex justify-content-between"
                )}
              >
                <span className={"styles.sidebarTitle fw-bold"}>
                  SUBSCRIPTIONS
                </span>
                <Link
                  className={styles.link}
                  to={"/my-profile-view#subscriptions"}
                >
                  See all
                </Link>
                {/* <AccessControl targetRoles={[INSTRUCTOR_ROLE]}>
                </AccessControl>
                <AccessControl targetRoles={[STUDENT_ROLE]}>
                  <Link className={styles.link} to={"/my-profile-view"}>
                    See all
                  </Link>
                </AccessControl> */}
              </div>
            )}
            {showAllSubscription
              ? allSubscription.data?.map((item, index) => (
                  <SubscriptionItem
                    key={item.id}
                    {...item}
                    showTitle={!isShowMini}
                  />
                ))
              : allSubscription.data
                  ?.slice(0, numOfShowSubscription)
                  .map((item, index) => (
                    <SubscriptionItem
                      key={item.id}
                      {...item}
                      showTitle={!isShowMini}
                    />
                  ))}
            {totalSubscription > numOfShowSubscription && (
              <>
                <SubMenu
                  title={
                    showAllSubscription
                      ? "Show less"
                      : `Show more (${
                          totalSubscription - numOfShowSubscription
                        })`
                  }
                  // path="/all-instructors"
                  // isActive={activeTab === "/all-instructors"}
                  targetRoles={[STUDENT_ROLE, INSTRUCTOR_ROLE]}
                  icon={
                    showAllSubscription ? (
                      <i className="bi bi-chevron-up"></i>
                    ) : (
                      <i className="bi bi-chevron-down"></i>
                    )
                  }
                  showTitle={!isShowMini}
                  onAfterClick={handleAfterClickLink}
                  onClick={() => {
                    setShowAllSubscription(!showAllSubscription);
                  }}
                />
              </>
            )}
          </Fragment>
        </AccessControl>
        <SubMenu
          title="Browse Instructors"
          path="/all-instructors"
          isActive={activeTab === "/all-instructors"}
          targetRoles={[GUEST_ROLE, STUDENT_ROLE, INSTRUCTOR_ROLE]}
          icon={<i className="bi bi-plus-circle sidebar-icon"></i>}
          showTitle={!isShowMini}
          onAfterClick={handleAfterClickLink}
        />
      </Fragment>
    );
  }

  // effects
  useLayoutEffect(() => {
    const arrPath = location.pathname.split("/");
    setActiveTab(`/${arrPath[1]}`);
  }, [location.pathname]);

  useEffect(() => {
    dispatch(allSubscriptionAction());
  }, [subscribe, unsubscribe]);

  // render
  return (
    <Fragment>
      <nav className={clsx(styles.sidebar, sidebarClass)}>
        <div className={styles.sidebarGroup}>
          {sidebarLinkListData.map((item, index) => {
            return (
              <SubMenu
                key={item.path + index}
                {...item}
                showTitle={!isShowMini}
                targetRoles={item.roles || []}
                isActive={activeTab === item.path}
                onAfterClick={handleAfterClickLink}
              />
            );
          })}
        </div>

        {subscriptionMenu}

        <div className={styles.sidebarGroup}>
          {settingMenuListData.map((item, index) => (
            <SubMenu
              targetRoles={item.roles || []}
              key={item.path + index}
              {...item}
              showTitle={!isShowMini}
              isActive={activeTab === item.path}
              onAfterClick={handleAfterClickLink}
            />
          ))}
        </div>
        {/* {mode === SIDEBAR_MODE.DEFAULT && !isShowMini && (
          <div className={styles.leftFooter}>
            <div>
              {footerLeftItemList.map((item, index) => {
                return (
                  <a
                    className={styles.leftFooterLink}
                    key={item.path + index}
                    href={item.path}
                  >
                    {item.title}
                  </a>
                );
              })}
            </div>
          </div>
        )} */}
      </nav>
      {isShow && !isShowMini && (
        <div
          className={styles.sidebarOverlay}
          onClick={() => {
            onChangeSidebar(SIDEBAR_STATUS.HIDE);
          }}
        ></div>
      )}
    </Fragment>
  );
}

/* required: display name */
MainSidebar.displayName = "MainSidebar";

/* required: props types */
MainSidebar.propTypes = {
  status: oneOf([
    SIDEBAR_STATUS.FULL,
    SIDEBAR_STATUS.MINI,
    SIDEBAR_STATUS.HIDE,
  ]),
  mode: oneOf([
    SIDEBAR_MODE.DEFAULT,
    SIDEBAR_MODE.DASHBOARD,
    SIDEBAR_MODE.ADMIN,
  ]),
  onChangeSidebar: func,
};

/* required: default props */
MainSidebar.defaultProps = {
  status: SIDEBAR_STATUS.FULL,
  mode: SIDEBAR_MODE.DEFAULT,
  onChangeSidebar: () => {},
};

export { MainSidebar };
